import React, { ChangeEvent } from "react";
import DollarSign from "../../../assets/dollar.png";

interface TargetTextfieldProps {
  name: string;
  value: string | number;
  onValueChange: (value: string) => void;
  disabled?: boolean;
}

const TargetTextfield: React.FC<TargetTextfieldProps> = ({
  name,
  value,
  onValueChange,
  disabled,
}) => {
  const formattedValue =
    value === "" || value === 0
      ? ""
      : new Intl.NumberFormat("en-US").format(Number(value));

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replace(/,/g, "");
    const numericValue = Number(rawValue);

    if (
      rawValue === "" ||
      (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 1000000)
    ) {
      onValueChange(rawValue);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "-" || event.key === "e") {
      event.preventDefault();
    }
  };

  return (
    <>
      <div
        style={{
          boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.07) inset",
        }}
        className="flex items-center rounded-[8px] border-[1px] border-[#E2E2E2] bg-[#F8F8F8]"
      >
        <input
          style={{
            boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.07) inset",
          }}
          type="text"
          id={`goal-${name}-input`}
          name="goal-${name}t"
          aria-label={name}
          data-testid={`goal-${name}-input`}
          className={`peer block w-full appearance-none rounded-l-[8px] border-none bg-[#F8F8F8] px-[12px] h-[56px]  text-[18px] font-normal leading-[127%] text-black focus:outline-none focus:ring-0`}
          value={formattedValue}
          placeholder="Goal target"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          min="0"
          max={1000000}
          step="any"
          onPaste={(e) => {
            const pastedData = e.clipboardData.getData("text");
            if (Number(pastedData) < 0) {
              e.preventDefault();
            }
          }}
          disabled={disabled}
        />
        <img
          src={DollarSign}
          className="w-[21px] h-[21px] mx-[12px] object-contain"
          alt="Dollar"
        />
      </div>
    </>
  );
};

export default TargetTextfield;
